module.exports = __webpack_public_path__ + "img/banner1.bf18c8b3.jpg";